/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Label, Alert, Button, InputGroup,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Formik, Field, Form, ErrorMessage, FieldArray,
} from 'formik';
import * as Yup from 'yup';
import { post, put } from '../../helpers/api_helper';
import BaseGrid from '../Common/BaseGrid';

function MassUpdateForm(props) {
  const {
    t,
    onSuccess,
  } = props;

  const [propSelector, setPropSelector] = useState(false);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const ValidationSchema = Yup.object().shape({
    properties: Yup.array().of(Yup.object().shape({
      id: Yup.number(),
      value: Yup.string().required(t('Value is required')),
    })),
    skus: Yup.string().required(t('At least 1 sku required')),
  });

  const massUpdate = async (data) => {
    try {
      await post('/api/fuse/property/massUpdateProperties', data);

      toastr.success('Item properties updated!', t('Success'));
      onSuccess({});
    } catch (error) {
      toastr.error(error.message, t('Error while creating'));
    }
  };

  const jsx = (
    <Formik
      enableReinitialize
      initialValues={{ skus: '', properties: [] }}
      validationSchema={ValidationSchema}
      onSubmit={(values) => {
        const newData = {
          skus: values.skus.split('\n'),
          properties: values.properties.map((x) => ({
            id: x.id,
            value: x.value,
          })),
        };

        massUpdate(newData);
      }}
    >
      {({
        touched, errors, values, setFieldValue,
      }) => (
        <Form id="FuseMassUpdateForm" autoComplete="off">
          <Row>
            <Col sm="12">
              <Label
                for="skus"
              >
                {props.t('Skus')}
                {' '}
                <sup className="text-danger">*</sup>
              </Label>
              <Field as="textarea" className="form-control" name="skus" />
              <div className="text-muted mt-1">{t('One per line')}</div>
            </Col>
          </Row>

          <Label
            for="properties"
            className="mt-3"
          >
            {props.t('Properties')}
            {' '}
            <sup className="text-danger">*</sup>
          </Label>

          {propSelector !== false && (
            <div className="mt-3 mb-3">
              <BaseGrid
                url="/api/fuse/property"
                hasSearch
                shouldPaginate
                config={
                {
                  columns: {
                    label: {
                      label: 'Label',
                      sort: true,
                    },
                    actions: {
                      label: props.t('Actions'),
                      actions: [
                        {
                          key: 'select',
                          icon: 'mdi mdi-check',
                          class: 'btn btn-sm btn-soft-danger',
                          alt: props.t('Select'),
                          click: (p) => {
                            setFieldValue(`properties[${propSelector}]`, p);
                            setPropSelector(false);
                          },
                        },
                      ],
                    },
                  },
                  pagination: {
                    sort: 'id',
                    direction: 'desc',
                    perPage: 10,
                  },
                }
                }
              />
            </div>
          )}

          <FieldArray name="properties">
            {({ push, remove }) => (
              <div>
                {values.properties && values.properties.length > 0 ? (
                  values.properties.map((prop, index) => (
                    <Row key={index} className="mb-2">
                      <Col md="6">
                        <InputGroup>
                          {prop.id === '' && (
                            <Button size="sm" color="link" type="button" onClick={() => { setPropSelector(index); }}>
                              {t('Select a property...')}
                            </Button>
                          )}
                          {prop.id !== '' && (
                            <input className="form-control form-control-sm" readOnly value={prop.label} />
                          )}
                          <Button
                            type="button"
                            color="danger"
                            size="sm"
                            onClick={() => remove(index)}
                          >
                            <span className="mdi mdi-close-thick" />
                          </Button>
                        </InputGroup>
                      </Col>
                      <Col md="6">
                        {prop.id !== '' && prop.choices && (
                          <Field
                            as="select"
                            name={`properties[${index}].value`}
                            className="form-control form-control-sm"
                          >
                            <option>{t('Choose...')}</option>
                            {(JSON.parse(prop.choices))
                              .map((s) => s.trim())
                              .filter(Boolean)
                              .map((choice) => (
                                <option key={choice} value={choice}>
                                  {choice}
                                </option>
                              ))}
                          </Field>
                        )}
                      </Col>
                    </Row>
                  ))
                ) : (
                  <div className="text-muted mb-2">{t('No properties added')}</div>
                )}

                <Button
                  type="button"
                  color="primary"
                  className="mb-3"
                  size="sm"
                  onClick={() => push({ id: '', value: '' })}
                >
                  {t('Add Property')}
                </Button>
              </div>
            )}
          </FieldArray>
        </Form>
      )}
    </Formik>
  );

  return jsx;
}

MassUpdateForm.defaultProps = {
  onSuccess: () => {},
};

MassUpdateForm.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  onSuccess: PropTypes.func,
};

export default connect((state) => ({

}), {})(withTranslation()(MassUpdateForm));
